// Auto-generated AWS Configuration for Trading Bot Frontend
// This file is automatically updated by the deployment script
// Last updated: Thu Sep 11 00:27:19 MDT 2025

export const awsConfig = {
  Auth: {
    region: 'us-east-1',
    Cognito: {
      userPoolId: 'us-east-1_70vtZDdGz',
      userPoolClientId: '5jg59agir8trtpcb7v13vbeqea',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        phone: false,
        username: false,
        oauth: {
          domain: 'shingamitrades-auth.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'profile', 'openid'],
          responseType: 'code',
          redirectSignIn: [
            'http://localhost:5173/',
            'http://localhost:3000/',
            'https://app.shinigamitrades.com/',
            'https://dughp31jsfmp4.cloudfront.net/',
            'https://d1twmaafjijnqe.cloudfront.net/'
          ],
          redirectSignOut: [
            'http://localhost:5173/',
            'http://localhost:3000/',
            'https://app.shinigamitrades.com/',
            'https://dughp31jsfmp4.cloudfront.net/',
            'https://d1twmaafjijnqe.cloudfront.net/'
          ]
        }
      }
    }
  },
  API: {
    REST: {
      TradingAPI: {
        endpoint: 'https://j7tzg71dx5.execute-api.us-east-1.amazonaws.com/prod',
        region: 'us-east-1'
      }
    }
  }
};

// Environment-specific configurations
export const getConfig = () => {
  const env = process.env.NODE_ENV || 'development';

  if (env === 'production') {
    // Production: env vars override; otherwise use same single source (awsConfig)
    const apiEndpoint = (import.meta && import.meta.env && import.meta.env.VITE_API_URL)
      ? import.meta.env.VITE_API_URL
      : (awsConfig.API?.REST?.TradingAPI?.endpoint ?? '');
    return {
      Auth: {
        region: process.env.REACT_APP_AWS_REGION || awsConfig.Auth?.region || 'us-east-1',
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || (awsConfig.Auth?.Cognito?.userPoolId ?? ''),
        userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || (awsConfig.Auth?.Cognito?.userPoolClientId ?? ''),
      },
      API: {
        endpoints: [
          {
            name: 'TradingAPI',
            endpoint: apiEndpoint,
            region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
          },
        ],
      },
    };
  }

  // Development configuration
  return awsConfig;
};

// Helper function to get API endpoint
export const getApiEndpoint = () => {
  const config = getConfig();
  return config.API?.endpoints?.[0]?.endpoint ?? config.API?.REST?.TradingAPI?.endpoint ?? '';
};

/** Full URL for an API path; trims trailing slash on base so paths never become `//admin/...`. */
export const apiUrl = (path) => {
  const raw =
    (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_API_URL) ||
    getApiEndpoint() ||
    '';
  const base = String(raw).replace(/\/+$/, '');
  const p = String(path ?? '').replace(/^\/+/, '');
  return base ? `${base}/${p}` : `/${p}`;
};

// Helper function to get Cognito User Pool ID (supports both getConfig() shapes)
export const getCognitoUserPoolId = () => {
  const config = getConfig();
  return config.Auth?.userPoolId ?? config.Auth?.Cognito?.userPoolId ?? '';
};

// Helper function to get Cognito Client ID (supports both getConfig() shapes)
export const getCognitoClientId = () => {
  const config = getConfig();
  return config.Auth?.userPoolWebClientId ?? config.Auth?.Cognito?.userPoolClientId ?? '';
};

export default awsConfig;
